<template>
  <div class="match-indicator">
    <svg-icon name="Match16" kind="indicative" />
    <span>{{ t("match_indicator_label") }}</span>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>

<style lang="scss">
@import "@styles/themes/sls-theme/tokens/colors";
@import "@styles/themes/sls-theme/tokens/spacing";
@import "@styles/themes/sls-theme/tokens/typo";

.match-indicator {
  display: flex;
  align-items: center;
  gap: $spacing-02;

  span {
    @include carbon--type-style("card-label-01");
    color: $searchmatch-01;
  }
}
</style>
